// extracted by mini-css-extract-plugin
export default {"gad-e":"EmptyCart-gad-e_l6VPF"};